module.exports = __webpack_public_path__ + "img/feature_b08.468a3a4d.svg";